const game = {

	/**
	 * The game app.
	 *
	 * @type {object}
	 */
	app: null,


	/**
	 * Constants for the game modes.
	 *
	 * @type {int}
	 */
	MODE_MENU: 1,
	MODE_PLAY: 2,
	MODE_FINISH: 3,
	MODE_COUNTDOWN: 4,


	/**
	 * Length of game in seconds.
	 *
	 * @type {int}
	 */
	gameLength: 60,


	/**
	 * Levels to select from.
	 *
	 * @type {array}
	 */
	levels: [
		{ n: '1 letter', v: 1, p: false },
		{ n: '3 letters', v: 3, p: false },
		{ n: '4 letters', v: 4, p: false },
		// { n: '5 letters', v: 5, p: true },
		// { n: '6 letters', v: 6, p: true },
		// { n: '7 letters', v: 7, p: true },
	],


	input: null,


	/**
	 * Initialize the app.
	 */
	init: function() {

		if ( game.app ) {
			return;
		}

		const $comp = document.querySelector( '#game-container' );

		game.app = new Reef(
			$comp,
			{
				data: {
					currentWord: '',
					nextLetter: '',
					typed: '',
					correct: 0,
					mode: game.MODE_MENU,
					timeRemaining: 3,
					hasFocus: true,
					wordLength: 3,
				},
				template: game.template,
			}
		);

		game.app.render();

		$comp.addEventListener( 'click', game.click );
		// Radio buttons for selecting word length.
		$comp.addEventListener( 'change', game.click );

		// Keyboard input.
		game.input = document.querySelector( '#gameInput' );
		game.input.addEventListener( 'input', game.keyup );

	},


	/**
	 * Create a new game.
	 *
	 * @return {void}
	 */
	newGame: function() {

		const firstWord = game.pickWord();
		const firstLetter = firstWord[ 0 ];

		game.app.setData(
			{
				currentWord: firstWord,
				nextLetter: firstLetter,
				typed: '',
				correct: 0,
				timeRemaining: 3,
				mode: game.MODE_COUNTDOWN,
			}
		);

	},


	/**
	 * Pick a word.
	 *
	 * @param {string} currentWord The current word to check.
	 * @return {string}
	 */
	pickWord: function( currentWord = '' ) {

		const words = wordList[ game.app.data.wordLength ];
		let word = currentWord;

		// Make sure the word is not the same as the previous one.
		do {
			word = words[ Math.floor( Math.random() * words.length ) ].toLowerCase();
		} while ( word === currentWord );

		return word;

	},


	/**
	 * The template wrapper.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	template: function( props ) {

		let html = '';

		switch ( props.mode ) {
			case game.MODE_MENU:
				html += game.templateMenu( props );
				break;

			case game.MODE_PLAY:
				html += game.templateGame( props );
				break;

			case game.MODE_FINISH:
				html += game.templateFinish( props );
				break;

			case game.MODE_COUNTDOWN:
				html += game.templateCountdown( props );
				break;

		}

		return html;

	},


	/**
	 * The menu template.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templateMenu: function( props ) {

		return `
			<h1 class="m-b4">Typing Ninja<span class="carat"></span></h1>
			<button class="button jumbo m-b5" data-action="play">Play</button>
			${game.templatePartWordLength( props )}
		`;

	},


	/**
	 * The game template.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templateGame: function( props ) {

		let word = `<span>${props.typed}</span><span class="carat"></span><span class="o50">${props.currentWord.replace( props.typed, '' )}</span>`;

		return `
			<div class="f1 m-b5" id="theWord">${word}</div>
			<div class="f3 fg-blue-dark f-fw900">${props.timeRemaining}</div>
			${game.focusGameButton( props )}
		`;

	},


	/**
	 * Display the focus game button.
	 * This is only needed on touch devices.
	 * It allows the user to display the keyboard.
	 * This is because the keyboard is hidden by default on touch devices.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	focusGameButton: function( props ) {

		if ( !props.hasFocus ) {
			return `<button data-action="focus">Display Keyboard</button>`;
		}

		return ``;

	},


	/**
	 * Focus the keyboard.
	 *
	 * @return {void}
	 */
	focusKeyboard: function() {

		if ( game.input ) {

			game.input.focus();

			game.app.setData(
				{
					hasFocus: true
				}
			);

		}

	},


	/**
	 * The game finished template.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templateFinish: function( props ) {

		// Description.
		let description = `, ${props.wordLength} Letter Words`;

		if ( 1 === parseInt( props.wordLength ) ) {
			// Needs a space after the word before.
			description = ' Letters';
		}

		// Title.
		let title = 'Oh No 😞';

		if ( props.correct > 0 ) {
			title = 'Nice Try! 👍';
		}

		if ( props.correct > 10 ) {
			title = 'Way to go! 😊';
		}

		if ( props.correct > 20 ) {
			title = '🏅 Well Done! 😃';
		}

		if ( props.correct > 30 ) {
			title = '🥉 Great Job! 😎';
		}

		if ( props.correct > 40 ) {
			title = '🥈 Amazing! 🤩';
		}

		if ( props.correct > 50 ) {
			title = '🥇 Outstanding! 🌟';
		}

		return `
			<div class="f1 m-b4 f-fw900">${title}</div>
			<div class="f2 m-b5"><strong class="fg-green-dark">${props.correct}</strong>${description}</div>
			<button class="button" data-action="again">Play Again</button>
		`;

	},


	/**
	 * The game intro countdown.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templateCountdown: function( props ) {

		return `
			<div class="f1 fg-blue f-fw900">${props.timeRemaining}</div>
		`;

	},


	/**
	 * Display the word length settings.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templatePartWordLength: function( props ) {

		let html = '';

		game.levels.forEach(
			( item ) => {
				let checked = '';

				if ( props.wordLength === item.v ) {
					checked = 'checked="checked"';
				}

				html += `<input type="radio" name="wordLength" data-action="changeWordLength" label="${item.n}" value="${item.v}" ${checked} />`;
			}
		);

		return `<div class="radioGroup word-length">${html}</div>`;

	},


	/**
	 * The click events.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	click: function( e ) {

		const action = e.target.getAttribute( 'data-action' );

		// console.log( action );

		if ( !action ) {
			game.focusKeyboard();
			return;
		}

		e.preventDefault();

		// Play the game.
		if ( 'play' === action ) {

			game.newGame();
			game.focusKeyboard();

			let countdownDuration = 1000;

			setTimeout( game.updateCountdown, countdownDuration );

		}

		// Play again (and go back to the main menu).
		if ( 'again' === action ) {

			game.app.setData(
				{
					mode: game.MODE_MENU,
				}
			);

		}

		// Focus the input.
		if ( 'focus' === action ) {

			game.focusKeyboard();

		}

		// Change the word length.
		if ( 'changeWordLength' === action ) {

			game.app.setData(
				{
					wordLength: parseInt( e.target.value )
				}
			);

			setTimeout( () => { game.app.render() }, 10 );

		}

	},


	/**
	 * Update the intro countdown timer.
	 *
	 * @return {void}
	 */
	updateCountdown: function() {

		if ( game.updateTimer( game.MODE_PLAY ) ) {

			// Update the countdown.
			setTimeout( game.updateCountdown, 1000 );

		} else {

			// Countdown ended so switch to 'play' mode.
			game.app.setData(
				{
					timeRemaining: game.gameLength
				}
			);

			setTimeout( game.updateTime, 1000 );

		}

	},


	/**
	 * Update the play timer.
	 *
	 * @return {void}
	 */
	updateTime: function() {

		if ( game.updateTimer() ) {

			setTimeout( game.updateTime, 1000 );

			const $focused = document.activeElement;
			if ( 'gameInput' !== $focused.id ) {

				game.focusKeyboard();

				if ( is_touch_device() ) {

					game.app.setData(
						{
							hasFocus: false,
						}
					);

				}

			}

		}

	},


	/**
	 * Global app timer for all timed events.
	 *
	 * @param {int} next_mode The next mode to change to when the time runs out.
	 * @return {boolean} True if the timer is continuing and false if it has expired.
	 */
	updateTimer: function( next_mode = game.MODE_FINISH ) {

		const data = game.app.data;
		const time_remaining = data.timeRemaining - 1;

		// Time has run out.
		if ( time_remaining === 0 ) {

			game.app.setData(
				{
					mode: next_mode
				}
			);

			return false;

		}

		// Update the app time remaining.
		game.app.setData(
			{
				timeRemaining: time_remaining
			}
		);

		return true;

	},


	/**
	 * The keyup event.
	 *
	 * @param {event} e The keyup event.
	 * @return {void}
	 */
	keyup: function( e ) {

		// Input element id.
		const $target = e.target;
		const id = $target.id;
		const value = $target.value;

		if ( 'gameInput' !== id ) {
			return;
		}

		// Get data.
		const data = game.app.data;

		// Quit if the game isn't playing.
		if ( game.MODE_PLAY !== data.mode ) {
			return;
		}

		// Get the typed character.
		// const character = String.fromCharCode( e.keyCode ).toLowerCase();
		const character = value.charAt( value.length - 1 ).toLowerCase();

		if ( !character ) {
			return;
		}

		// Get the default values.
		let typed = data.typed;
		let currentWord = data.currentWord;
		let nextLetter = data.nextLetter;
		let correct = data.correct;

		// If the typed character is the same as the next letter.
		if ( character === nextLetter ) {
			typed = data.typed + character;
			nextLetter = currentWord.replace( typed, '' )[ 0 ];
		}

		// If the typed word is the same as the target word.
		// Select the next word and reset everything.
		if ( typed === currentWord ) {
			typed = '';
			currentWord = game.pickWord( currentWord );
			nextLetter = currentWord[ 0 ];
			correct++;

			game.explode( 'theWord' );
		}

		// Update everything.
		game.app.setData(
			{
				typed,
				currentWord,
				nextLetter,
				correct,
			}
		);

		game.input.value = '';

	},


	/**
	 * Explode confetti.
	 *
	 * @param {string} id The element to target.
	 * @return {void}
	 */
	explode: function( id ) {

		confetti(
			{
				particleCount: 60,
				spread: 360,
				ticks: 70,
				origin: { y: 0.3 },
				gravity: 0.75,
				startVelocity: 30,
				scalar: 1.75,
				disableForReducedMotion: true,
			}
		);

	},

};

